// extracted by mini-css-extract-plugin
export default {"center-justified":"About_center-justified__huG38","center-image":"About_center-image__sgiyc","bold":"About_bold__+dJad"};